import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/ProductCard.css";

// Import our price formatter helper
import { formatPrice } from "../utils/formatPrice"; // Adjust the import path as needed

const ProductCard = ({ product, onAddToCart }) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const navigate = useNavigate();
  const salePrice = product.price * (1 - product.discountPercentage / 100);
  const truncatedDescription = product.description.length > 80
    ? `${product.description.substring(0, 77)}...`
    : product.description;

  // Get the first image URL or fallback to default image
  const firstImage = product.images?.[0]?.imageUrl || product.imageUrl;

  const getCategoryPath = (category) => {
    let path = [];
    let currentCategory = category;

    while (currentCategory) {
      path.unshift(currentCategory.name);
      currentCategory = currentCategory.parentCategory;
    }

    return path.length > 0 ? path.join(" | ") : category?.name || "";
  };

  // Handle click on the product card
  const handleCardClick = () => {
    if (window.innerWidth <= 768) { // Check if in mobile mode
      navigate(`/home/product/${product.id}`);
    }
  };

  return (
    <div className="product-card" onClick={handleCardClick}>
      <div className="image-container">
        <img
          src={
            firstImage?.startsWith('http')
              ? firstImage
              :  `${API_BASE_URL}${firstImage}`
          }
          alt={product.name}
          className="product-image"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/noImage.jpg";
          }}
        />
        {product.onSale && <div className="sale-badge">Na popustu</div>}
      </div>

      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-category">
          {getCategoryPath(product.category)}
        </p>

        <div className="price-container">
          {product.onSale ? (
            <>
              <span className="original-price">
                {formatPrice(product.price)} RSD
              </span>
              <span className="sale-price">
                {formatPrice(salePrice)} RSD
              </span>
            </>
          ) : (
            <span className="price">{formatPrice(product.price)} RSD</span>
          )}
        </div>
      </div>

      <div className="product-buttons">
        <button className="buy-button" onClick={(e) => {
          e.stopPropagation(); // Prevent card click event
          onAddToCart(product);
        }}>
          Dodaj u Korpu
        </button>
        <Link
          to={`/home/product/${product.id}`}
          className="view-more-button"
          onClick={(e) => e.stopPropagation()}
        >
          Vidi Više
        </Link>
      </div>
    </div>
  );
};

export default ProductCard;